import { useWebViewMode } from '@/hooks/useWebViewMode'

import { Footer, Header } from '../Navigation'
import type { FooterProps, HeaderProps } from '../Navigation'

type WebViewProps = {
  children: React.ReactNode
  title?: string
  hasFooter?: boolean
} & FooterProps &
  HeaderProps

export const WebView = ({
  children,
  title,
  ptSize,
  isFixed,
  hasFooter = true,
}: WebViewProps) => {
  const isWebViewMode = useWebViewMode({ title })

  return (
    <div className="flex flex-col min-h-screen">
      {isWebViewMode === false && <Header isFixed={isFixed} />}
      <main className="flex flex-col flex-grow mx-auto w-full sm:w-[375px]">
        {children}
      </main>
      {isWebViewMode === false && hasFooter && <Footer ptSize={ptSize} />}
    </div>
  )
}
